import { render, staticRenderFns } from "./addSysDocumentView.vue?vue&type=template&id=a6615b4a"
import script from "./addSysDocumentView.vue?vue&type=script&lang=js"
export * from "./addSysDocumentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports